// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { CheckEmailAuthEmailCheckPostMutationRequest, CheckEmailAuthEmailCheckPostMutationResponse, CheckEmailAuthEmailCheckPost422 } from "../models/emailAuthController/CheckEmailAuthEmailCheckPost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getCheckEmailAuthEmailCheckPostUrl() {
  const res = { method: 'POST', url: `/auth/email/check` as const }
  return res
}

/**
 * @description Check if email is already registered.
 * Returns whether the email exists in the system.
 * @summary Check Email
 * {@link /auth/email/check}
 */
export async function checkEmailAuthEmailCheckPost(data: CheckEmailAuthEmailCheckPostMutationRequest, config: Partial<RequestConfig<CheckEmailAuthEmailCheckPostMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CheckEmailAuthEmailCheckPostMutationResponse, ResponseErrorConfig<CheckEmailAuthEmailCheckPost422>, CheckEmailAuthEmailCheckPostMutationRequest>({ method : "POST", url : getCheckEmailAuthEmailCheckPostUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}